import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import BreadCrumb from "components/BreadCrumb/";
import SearchCategory from "components/Error404/SearchCategory";
import Icon404 from "components/Error404/Icon404";
import style from './style.scss'; //NOSONAR

const crumbs = [{
    title: 'Resultados de Búsqueda',
    url: ""
}];

const Error404 = (props) => {

    const getSearch = () => {
        const params = queryString.parse(props.location.search);

        return {
            term: params.ft || '',
            product: params.ProductLinkNotFound || ''

        };
    }

    const search = getSearch();

    return (
        <div className="error-404-page page">
            <main>
                <div className="container">
                    <BreadCrumb crumbs={crumbs} />
                    <div className="error-404-empty-message">
                        <Icon404 />
                        {search.product && <h2 className="error-404-subtitle">No encontramos resultados para este producto</h2>}
                        {!search.product && search.term && (<h2 className="error-404-subtitle">
                            No encontramos resultados para tu búsqueda {'"'}<span className="error-404-search-term">{search.term}</span>{'"'}
                        </h2>)}
                        {!search.product && !search.term && (<h2 className="error-404-subtitle">La página que estás buscando no existe</h2>)}

                        {(search.product || search.term) && <ul className="error-404-help-list">
                            <li>
                                <i className="font-icn check" />
                                <span>Revisa la ortografía</span>
                            </li>
                            <li>
                                <i className="font-icn check" />
                                <span>Simplifica la búsqueda con términos menos específicos</span>
                            </li>
                        </ul>}
                    </div>
                    <SearchCategory />
                </div>
            </main>
        </div>
    )
}

Error404.propTypes = {
    location: PropTypes.object,
};


export default Error404;
